// extracted by mini-css-extract-plugin
module.exports = {"LoadingComponent":"styles_LoadingComponent__G1_zy","spinner":"styles_spinner__jAltr"};